import { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

const FreeGamesByFawesomeInner = () => {
  const { id, title } = useParams();

  const iframeRef = useRef(null);
  const navigate = useNavigate();

  let authToken = "1217575";
  let appid = window.ip || "";
  if (appid) {
    appid = appid.split(".").join("-");
  }
  let appId = "9";
  let siteId = "236";
  let apptype = "iptvwebsite-fawesome---free-movies-and-tv-shows";
  let gameDomain = "games.freeawesometv.com";
  if (window.location.hostname === "fawesome.tv") {
    gameDomain = "games.fawesome.tv";
  }
  let url = `https://${gameDomain}/games/${id}/?&auth-token=${authToken}&appid=${appid}&appId=${appId}&version=sv6.0&apptype=${apptype}&siteId=${siteId}&deviceModel=&firmware=&logdomain=log.ifood.tv&x=0&y=0&actionkey=${id}`;

  // Example: Replace with actual current VOD info
  const currVodInfo = {
    channel: { title: "SampleChannel", actionkey: "12345" },
    x: 100,
    y: 200,
  };
  // Function to unload the game
  const unloadGame = () => {
    if (iframeRef.current) {
      iframeRef.current.src = "";
    }
    // Instead of showing/hiding manually, navigate back to games page
    navigate("/games");
  };

  // Handle postMessage from iframe
  const handlePostMessages = (event) => {
    //console.log("Received message from iframe:", event.data);

    // Example event.data validation
    if (!event.data || typeof event.data !== "object") return;

    const { channel, x, y } = currVodInfo;

    if (event.data.type == "exitGame") {
      logUserAction(
        `q=user&actiontype=backToOTT_${title}&actionkey=${id}&Xactionindex=&Yactionindex=&errorcode=&errormsg=&auth-token=${authToken}&appid=${appid}&appId=${appId}&version=sv6.0&apptype=${apptype}&siteId=${siteId}&deviceModel=&firmware=&format=json`
      );
      unloadGame();
    }
  };

  const logUserAction = (params) => {
    const url = `https://log.ifood.tv/applogger.php?${params}`;

    // Fire-and-forget logging
    /*const img = new Image();
    img.src = url;*/
    navigator.sendBeacon(url);

    //console.log("Log sent:", url);
  };

  useEffect(() => {
    logUserAction(
      `q=user&actiontype=exitingOTT_${title}&actionkey=${id}&Xactionindex=&Yactionindex=&errorcode=&errormsg=&auth-token=${authToken}&appid=${appid}&appId=${appId}&version=sv6.0&apptype=${apptype}&siteId=${siteId}&deviceModel=&firmware=&format=json`
    );
    // Attach listener
    window.addEventListener("message", handlePostMessages);

    return () => {
      // Clean up listener
      window.removeEventListener("message", handlePostMessages);
    };
  }, []);

  if (!id) return <p>Invalid game id</p>;

  return (
    <div
      id="game-container"
      style={{
        position: "relative",
        width: "100%",
        height: "100vh",
        background: "#fff",
      }}
    >
      <iframe
        id="game-iframe"
        src={url}
        style={{
          border: "none",
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          background: "#fff",
        }}
        allowFullScreen
        title={`Game ${id}`}
      />
    </div>
  );
};

export default FreeGamesByFawesomeInner;
